import LanguageDetector from 'i18next-browser-languagedetector';
import BackendAdapter from 'i18next-multiload-backend-adapter';

import { TeesterBackend } from './backend';
import { TeesterPostProcessor } from './post-processor';

export const makePlugins = (options) => ({
    backend: BackendAdapter,
    detector: LanguageDetector,
    postProcessor: new TeesterPostProcessor(options),
    /**
     * Common init options
     */
    get initOptions () {
        return {
            backend: {
                backend: new TeesterBackend(options),
            },
            detection: {
                order: ['querystring', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
                lookupQuerystring: 'lng',
                lookupLocalStorage: 'i18nextLng',
                caches: ['localStorage'],
            },
            interpolation: {
              escapeValue: false, // Front-end frameworks already escape values
            },
            fallbackLng: 'en', // Always load english to be used as fallback
            keySeparator: false, // Don't support nested keys
            nsSeparator: false, // Don't support namespaced keys
            saveMissing: true, // Report missing keys to backend
            postProcess: this.postProcessor.name, // Apply our post-processor
        };
    },
});
